/**
 * Permission Update Notifier
 * 
 * This utility provides a simple event-based notification system for permission changes.
 * It allows components to listen for permission updates and react accordingly.
 */

// Event listeners registry
let listeners = [];

/**
 * Subscribe to role permission change events
 * @param {Function} callback - Function to call when permissions change
 * @returns {Function} - Unsubscribe function
 */
export const subscribeToPermissionChanges = (callback) => {
  listeners.push(callback);
  
  // Return unsubscribe function
  return () => {
    listeners = listeners.filter(listener => listener !== callback);
  };
};

/**
 * Notify all listeners that role permissions have changed
 * @param {string} role - The role whose permissions changed
 * @param {Object} newPermissions - The updated permissions object
 * @param {string} [landingPage] - Optional landing page path for this role
 */
export const notifyRolePermissionsChanged = (role, newPermissions, landingPage) => {
  console.log(`📢 Notifying ${listeners.length} listeners of permission change for role: ${role}`);
  
  listeners.forEach(listener => {
    try {
      listener({ role, permissions: newPermissions, landingPage });
    } catch (error) {
      console.error('Error in permission change listener:', error);
    }
  });
};

/**
 * Clear all permission change listeners
 */
export const clearPermissionChangeListeners = () => {
  listeners = [];
  console.log('🗑️ Cleared all permission change listeners');
};

